export enum TimePeriodMode {
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly',
}
